// extracted by mini-css-extract-plugin
module.exports = {"modal":"NoteModal_modal__3XORJ","inner":"NoteModal_inner__2b0jB"};